import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Images, Newspaper, Play, Trash2 } from "lucide-react";
import { api, fmtDate, fmtErr } from "@/api";
import { useLang } from "@/i18n";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const TYPE_ICON = { galleries: Images, videos: Play, articles: Newspaper };
const COLL_ENDPOINT = { galleries: "galleries", videos: "videos", articles: "articles" };

export default function PersetujuanTab() {
  const { t, lang } = useLang();
  const [data, setData] = useState(null);

  const load = () => api.get("/admin/pending").then((r) => setData(r.data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const approve = async (coll, id) => {
    try {
      await api.post(`/admin/approve/${coll}/${id}`);
      toast.success(t("common.saved"));
      load();
    } catch (err) { toast.error(fmtErr(err)); }
  };

  const reject = async (coll, id) => {
    if (!window.confirm(t("common.confirm_delete"))) return;
    try {
      await api.delete(`/${COLL_ENDPOINT[coll]}/${id}`);
      toast.success(t("common.deleted"));
      load();
    } catch (err) { toast.error(fmtErr(err)); }
  };

  const all = data ? Object.entries(data).flatMap(([coll, items]) => items.map((it) => ({ ...it, _coll: coll }))) : [];
  const title = (it) => it.nama_kegiatan || it.title || "—";

  return (
    <div data-testid="persetujuan-tab">
      {all.length === 0 && <p className="text-sm text-slate-500" data-testid="persetujuan-empty">{t("approval.empty")}</p>}
      <div className="space-y-3">
        {all.map((it) => {
          const Icon = TYPE_ICON[it._coll] || Newspaper;
          return (
            <div key={it.id} className="bg-white rounded-xl border border-amber-300/60 shadow-sm p-4 flex flex-wrap items-center gap-4" data-testid={`pending-item-${it.id}`}>
              <span className="h-10 w-10 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center shrink-0"><Icon className="h-5 w-5" /></span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-semibold text-emerald-950 truncate">{title(it)}</p>
                  <Badge className="bg-amber-100 text-amber-800 border border-amber-300 hover:bg-amber-100">{it._type}</Badge>
                </div>
                <p className="text-xs text-slate-500 mt-0.5">
                  {it.uploader_name || it.author_name} · {fmtDate(it.created_at, lang)}
                  {it.photos ? ` · ${it.photos.length} foto` : ""}
                </p>
              </div>
              <div className="flex gap-2 shrink-0">
                <Button size="sm" onClick={() => approve(it._coll, it.id)} className="rounded-full bg-emerald-800 hover:bg-emerald-900" data-testid={`approve-${it.id}`}>
                  <Check className="h-3.5 w-3.5 mr-1" />{t("approval.approve")}
                </Button>
                <Button size="sm" variant="destructive" onClick={() => reject(it._coll, it.id)} data-testid={`reject-${it.id}`}>
                  <Trash2 className="h-3.5 w-3.5 mr-1" />{t("approval.reject")}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
